import { PicksView } from '../../../components/worldcup/PicksView/PicksView';

export default function WorldCupPicksRoute() {
  return <PicksView />;
}
